export default "__VITE_ASSET__fd6b6ee7__"